import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import ItemInformation from '../../../common/ItemInformation'
import ItemsInformation from '../../../common/ItemsInformation'
import Subtotal from '../../../common/Subtotal'
import { LANGUAGE } from '../../../constant'
import { convertAvailableFSData, handleVersionReport } from '../../../helper'
import classes from '../../../index.module.scss'
import { selectBusinessCreditReportDetail } from '../../../store/slice'

const ItemBusinessCreditReport = ({ id, index }) => {
  const detail = useSelector(selectBusinessCreditReportDetail(id))
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <>
      <Element
        style={{ borderTop: index ? '1px dashed #D5D5D5' : undefined }}
        className={`${classes.headerItem}`}
      >
        <Element style={{ color: '#0553A5' }} className="fw600">
          {detail?.companyName}
        </Element>
      </Element>

      <div className={classes.pdl28}>
        <div className={`dFlex ${classes.itemData}`}>
          <div className={classes.column1} />
          <Element className="fw600">{detail.reportType}</Element>
        </div>
        <ItemInformation
          title="cartAndOrders.main.version"
          value={handleVersionReport(
            detail.version,
            detail.dateCreated,
            detail.idTypeReport,
            locale,
          )}
        />
        <ItemInformation
          title={
            !detail?.version
              ? 'cartAndOrders.main.availableData'
              : 'cartAndOrders.main.reportingYear'
          }
          value={convertAvailableFSData(detail)}
        />
        <ItemInformation
          title="cartAndOrders.main.language"
          value={
            <Translate
              value={`cartAndOrders.main.${
                detail.language === LANGUAGE.EN ? 'ENGLISH' : 'VIETNAMESE'
              }`}
            />
          }
        />
        <ItemInformation
          title="cartAndOrders.main.currency"
          value={detail.currency}
        />
        <ItemsInformation
          data={[
            {
              title: 'cartAndOrders.main.additional',
              value: detail.additionalCurrency,
            },
          ]}
          style={{ gap: 2 }}
        />
        <Subtotal value={detail.subPrice} isSub={!!detail.discountPercentage} />
      </div>
    </>
  )
}

export default ItemBusinessCreditReport
